import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

export const isUserOnlyAFreeRegionalUser = () => {
  return userDetailsStore.getState().isFreeRegionalUser
}
